import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      /*
       * Fade on scroll
       */
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        gsap.registerPlugin( ScrollTrigger );
        $( '.js-fade:not(.js-ignore), .js-fade-group > *:not(.js-ignore)' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 90%',
              scrub: 0.15,
              refreshPriority: -1,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'js-animated' ),
            },
          } );
        } );

        /*
         * Reveal on scroll
         */
        $( '.js-reveal:not(.js-ignore)' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 90%',
              scrub: false,
              refreshPriority: -1,
            },
          } );
          tl.to( this, {clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)', duration: 1.5, ease: 'power4.inOut'} );
        } );

        $( '.hero-hero.with-line, .hdg-1.with-line, .hdg-2.with-line, .hdg-3.with-line, .hdg-4.with-line, .hdg-5.with-line, .hdg-6.with-line' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 90%',
              scrub: 0.15,
              refreshPriority: -1,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( this ).addClass( 'is-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'is-animated' ),
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
